// If adding new logos, you may need to delete the .next folder and then re-run yarn dev for the static files to be regenerated locally.

export { default as AddCar } from "./AddCar.inline.svg"
export { default as Alert } from "./Alert.inline.svg"
export { default as AltSignIn } from "./AltSignIn.inline.svg"
export { default as Approved } from "./Approved.inline.svg"
export { default as ApprovedFill } from "./ApprovedFill.large.inline.svg"
export { default as ArrowLeft } from "./ArrowLeft.inline.svg"
export { default as ArrowRight } from "./ArrowRight.inline.svg"
export { default as AutoTrader } from "./AutoTrader.inline.svg"
export { default as InterstitialAutoTraderLogo } from "./InterstitialAutoTraderLogo.svg"
export { default as InterstitialClearscoreLogo } from "./ClearscoreLogoOnly.inline.svg"
export { default as Calculator } from "./Calculator.inline.svg"
export { default as Call } from "./Call.inline.svg"
export { default as Car } from "./Car.inline.svg"
export { default as CarDealerReviewsLogo } from "./CarDealerReviewsLogo.inline.svg"
export { default as ChevronDown } from "./ChevronDown.inline.svg"
export { default as ChooseWiselyLogo } from "./ChooseWiselyLogo.inline.svg"
export { default as Close } from "./Close.inline.svg"
export { default as CloseBrothersLogo } from "./CloseBrothersLogo.inline.svg"
export { default as CompareniLogo } from "./CompareniLogo.inline.svg"
export { default as Edit } from "./Edit.inline.svg"
export { default as Email } from "./Email.inline.svg"
export { default as Favourite } from "./Favourite.inline.svg"
export { default as FavouriteFill } from "./FavouriteFill.inline.svg"
export { default as Finance } from "./Finance.inline.svg"
export { default as Help } from "./Help.inline.svg"
export { default as HelpFill } from "./HelpFill.inline.svg"
export { default as HintPointer } from "./HintPointer.inline.svg"
export { default as Home } from "./Home.inline.svg"
export { default as HonkHonkLogo } from "./HonkHonkLogo.inline.svg"
export { default as Inbox } from "./Inbox.inline.svg"
export { default as Info } from "./Info.inline.svg"
export { default as Location } from "./Location.inline.svg"
export { default as Menu } from "./Menu.inline.svg"
export { default as Mobile } from "./Mobile.inline.svg"
export { default as MotivLogo } from "./MotivLogo.inline.svg"
export { default as Office } from "./Office.inline.svg"
export { default as Oodle } from "./OodleLogo.inline.svg"
export { default as Outline } from "./Outline.large.inline.svg"
export { default as Padlock } from "./Padlock.inline.svg"
export { default as PadlockSmall } from "./PadlockSmall.inline.svg"
export { default as PadlockBold } from "./PadlockBold.inline.svg"
export { default as Paperwork } from "./Paperwork.inline.svg"
export { default as Photo } from "./Photo.inline.svg"
export { default as ProgradLogo } from "./ProgradLogo.inline.svg"
export { default as ProgressBarCar } from "./ProgressBarCar.inline.svg"
export { default as ProgressBarFinishPoleLeft } from "./ProgressBarFinishPoleLeft.inline.svg"
export { default as ProgressBarFinishPoleRight } from "./ProgressBarFinishPoleRight.inline.svg"
export { default as ProgressBarFinishFlag } from "./ProgressBarFinishFlag.inline.svg"
export { default as ProgressBarFlag } from "./ProgressBarFlag.inline.svg"
export { default as PoundSign } from "./PoundSign.inline.svg"
export { default as PoweredByZuto } from "./PoweredByZuto.inline.svg"
export { default as Search } from "./Search.inline.svg"
export { default as SearchCars } from "./SearchCars.inline.svg"
export { default as SignIn } from "./SignIn.inline.svg"
export { default as SmallTime } from "./SmallTime.inline.svg"
export { default as TandemLogo } from "./TandemLogo.inline.svg"
export { default as Tick } from "./Tick.inline.svg"
export { default as Time } from "./Time.inline.svg"
export { default as Trustpilot } from "./Trustpilot.inline.svg"
export { default as TrustpilotHeaderFallback } from "./TrustpilotHeaderFallback.svg"
export { default as TrustpilotReversed } from "./TrustpilotReversed.inline.svg"
export { default as TrustpilotVertical } from "./TrustpilotVertical.inline.svg"
export { default as TrustpilotVerticalSmallMobile } from "./TrustpilotVerticalSmallMobile.inline.svg"
export { default as TrustpilotVerticalSmallDesktop } from "./TrustpilotVerticalSmallDesktop.inline.svg"
export { default as ZutoLogo } from "./ZutoLogo.inline.svg"
export { default as ZutoLogoMedium } from "./ZutoLogoMedium.inline.svg"
export { default as ZutoLogoSmallMobile } from "./ZutoLogoSmallMobile.inline.svg"
export { default as ZutoLogoSmallDesktop } from "./ZutoLogoSmallDesktop.inline.svg"
export { default as ZutoLogoExperimental } from "./ZutoLogoExperimental.inline.svg"
export { default as SmallZutoLogo } from "./SmallZutoLogo.inline.svg"
export { default as InterstitialZutoLogo } from "./InterstitialZutoLogo.svg"
export { default as Bin } from "./Bin.inline.svg"
export { default as Loader } from "./Loader.inline.svg"
export { default as LargeAlert } from "./LargeAlert.inline.svg"
export { default as HeartWithBlob } from "./HeartWithBlob.inline.svg"
export { default as CarWithBlob } from "./CarWithBlob.inline.svg"
export { default as ApprovedWithBlob } from "./ApprovedWithBlob.inline.svg"
export { default as CloseToolTip } from "./CloseToolTip.inline.svg"
export { default as CarPlaceHolder } from "./CarPlaceHolder.inline.svg"
export { default as AdBlockZuto } from "./AdblockZuto.inline.svg"
export { default as TrustPilotLogo } from "./TrustpilotLogo.inline.svg"
export { default as Startline } from "./StartlineLogo.inline.svg"
export { default as Marsh } from "./Marsh.inline.svg"
export { default as Zopa } from "./ZopaLogo.inline.svg"
export { default as AutoLend } from "./AutolendLogo.inline.svg"
export { default as Moneybarn } from "./MoneyBarnLogo.inline.svg"
export { default as Moneyway } from "./MoneyWayLogo.inline.svg"
export { default as MoneySuperMarket } from "./MoneySuperMarketLogo.inline.svg"
export { default as MoneySuperMarketLarge } from "./MoneySuperMarketLargeLogo.inline.svg"
export { default as MoneySuperMarketStacked } from "./MoneySuperMarketStackedLogo.inline.svg"
export { default as OnePlusOneLoansLogo } from "./OnePlusOneLoansLogo.inline.svg"
export { default as QuoteZoneLogoMobile } from "./QuoteZoneLogoMobile.inline.svg"
export { default as QuoteZoneLogo } from "./QuoteZoneLogo.inline.svg"
export { default as TheLoanPeopleLogo } from "./TheLoanPeopleLogo.inline.svg"
export { default as TotallyMoneyLogo } from "./TotallyMoneyLogo.inline.svg"
export { default as LoantubeLogo } from "./LoantubeLogo.inline.svg"
export { default as WowcherLogo } from "./WowcherLogo.inline.svg"
export { default as CarmoolaLogo } from "./CarmoolaLogo.inline.svg"
export { default as ExperianLogo } from "./ExperianLogo.inline.svg"
export { default as CompareTheMarketLogo } from "./CompareTheMarketLogo.inline.svg"
